export default __webpack_public_path__ + "static/media/Appointy12.e97cc3d1.png";